"use client";
import React, { useEffect, useState } from "react";
import Image from "next/image";
import { Link } from "@/navigation";
import { useTranslations } from "next-intl";
import { ProductListItemFragment } from "@/gql/graphql";
import { filterCateImg } from "@/components/Home2/Collection";
import { defaultLocale } from "@/config";
import { replaceImgUrl } from "@/lib/utils.ts";
import { BodyText } from "../BodyText";

type dscObj = {
	data: { text: string };
	type: string;
};
type dscList = {
	blocks: dscObj[];
};
export const filterSortDsc = (dsc: string) => {
	let sortDsc = "";
	let longDsc = "";
	if (dsc) {
		const dscObj = JSON.parse(dsc) as dscList;

		if (dscObj && dscObj.blocks.length > 0) {
			sortDsc = dscObj.blocks[1].data.text;
			longDsc = dscObj.blocks[0].data.text;
		}
	}

	return { sortDsc, longDsc };
};

interface ProductListItemProps {
	productItem: ProductListItemFragment; // 确保属性名是正确的
	locale: string;
}

const ProductItemDefault: React.FC<ProductListItemProps> = ({ productItem, locale }) => {
	const t = useTranslations();

	const [htmlContent, setHtmlContent] = useState<string>("");

	useEffect(() => {
		const content =
			locale === defaultLocale
				? filterSortDsc(productItem?.descriptionJson).sortDsc
				: filterSortDsc(productItem?.translation?.descriptionJson).sortDsc;
		setHtmlContent(content);
	}, [productItem]);

	return (
		<>
			<Link
				href={"/product/" + productItem.slug}
				className="group block transform cursor-pointer overflow-hidden !rounded-lg border bg-white shadow-lg transition-all duration-700 hover:-translate-y-2 hover:shadow-[#a8b7d2]"
			>
				<Image
					src={replaceImgUrl(filterCateImg(productItem.metadata)[0]?.url) || "/image/default-image.webp"}
					alt={productItem.name}
					width={500}
					height={500}
					className="h-64 w-full object-cover "
				/>
				<div className="bg-[#f5f5f5] px-4 py-6">
					<h3 className="my-2  line-clamp-1 text-2xl font-bold text-black">
						{" "}
						{locale === defaultLocale
							? productItem.name
							: productItem.translation
								? productItem.translation.name
								: productItem.name}
					</h3>

					<BodyText
						className="my-2 line-clamp-4 text-xs font-normal text-[#677E6E] max-md:my-1 sm:text-sm "
						innerHTML={htmlContent}
					></BodyText>
					<span className="text-xs font-bold  text-main ">{t("base.viewMore")}</span>
				</div>
			</Link>
		</>
	);
};

export default ProductItemDefault;
